import { createRoot } from 'react-dom/client';
import { Provider } from '@rollbar/react';
import { RouterProvider } from '@tanstack/react-router';
import {
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query'
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(relativeTime);
dayjs.extend(utc);
dayjs.extend(timezone);

if (import.meta.env.MODE !== 'development') {
  (globalThis as any).litIssuedWarnings ??= new Set();
  (globalThis as any).litIssuedWarnings.add('dev-mode');
}

import router from './routes';

const rollbarConfig = {
  accessToken: import.meta.env.VITE_ROLLBAR_ACCESS_TOKEN,
  environment: import.meta.env.MODE || 'development',
  captureUncaught: true,
  captureUnhandledRejections: true,
  payload: {
    client: {
      javascript: {
        source_map_enabled: true,
      },
    },
  },
};

const queryClient = new QueryClient();

const root = createRoot(document.getElementById('lgcy-app')!);
root.render(
  <Provider config={rollbarConfig}>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </Provider>
);
